import { Currency, Form } from '@mairistem/composants';

import { useUpdateEffect } from '@mairistem/tools';
import React from 'react';

import type { NumeraireType } from '@/types';

import Montant from './Montant';

interface NumeraireProps {
  disabled: boolean;
  reste: number;
  montant: number;
  onChange: (value: NumeraireType, complet: boolean) => void;
  onError?: (error: string) => void;
}

const Numeraire = (props: NumeraireProps) => {
  const { disabled, reste, montant: montantProps, onChange, onError } = props;

  const [montant, setMontant] = React.useState<number>(montantProps || 0);
  const [percu, setPercu] = React.useState<number>(0);
  const [rendre, setRendre] = React.useState<number>(0);

  const handleChangePercu = (e, value) => {
    setPercu(value);
    setRendre(value - montant);
  };

  useUpdateEffect(() => {
    if (!disabled) {
      onChange({ ...(montant !== 0 && { montant }) }, montant > 0);
    }
  }, [disabled, montant]);

  useUpdateEffect(() => {
    if (montant !== 0 && montant > reste && onError) {
      onError('Le montant ne peut pas être supérieur au reste');
    }
  }, [montant, reste]);

  return (
    <Form.Group style={{ marginTop: 0, marginBottom: 0 }}>
      <Montant
        data-testid="montantNumeraire"
        disabled={disabled}
        reste={reste}
        montant={montant}
        onChange={setMontant}
        autoFocus={!disabled}
      />
      {!disabled && (
        <Form.Group inline style={{ flex: 1, marginBottom: 0 }}>
          <Form.Field width={3} />
          <Form.Field width={3}>
            <label>Rendu de monnaie :</label>
          </Form.Field>
          <Currency
            data-testid="percuNumeraire"
            value={percu}
            disabled={montant <= 0}
            inline
            label="Perçu"
            placeholder=""
            style={{ width: 100 }}
            valueMin={0}
            description=""
            onBlur={handleChangePercu}
          />
          <Currency
            data-testid="renduNumeraire"
            value={rendre < 0 ? 0 : rendre}
            label="A rendre"
            readOnly
            inline
            placeholder=""
            style={{ width: 100 }}
          />
        </Form.Group>
      )}
    </Form.Group>
  );
};

export default Numeraire;
